import { Divider } from './styles';

export const DetailsDividerRow = () => {
  return <Divider></Divider>;
};
